// Press Release v2 handoff — the React twin of app/services/press_releases/app_link.rb.
//
// When a company holds the `press-release-v2` FeatureGate, every Press Release AI
// entry point sends the customer to the external Press Release app (Craig's
// ListSend fork at pr.eventvesta.com) instead of the legacy in-app flow. The app
// authenticates the visitor from a per-company token in the path, using the
// EXACT same formula ListSend uses, so we reuse generateCompanyToken from
// listsendAuth.js rather than re-implementing it. Keep the Ruby twin in lock-step.
//
// Base URL: the Rails view stamps `press-release-app-url` on #react-root from
// PRESS_RELEASE_APP_URL (defaults to production); the constant below is only the
// fallback when the attribute is absent.

import { generateCompanyToken, getCompanyDataFromDOM } from "./listsendAuth.js"

export const PRESS_RELEASE_BASE_URL = "https://pr.eventvesta.com"
export const PRESS_RELEASE_V2_GATE = "press-release-v2"

export const getPressReleaseBaseUrl = () => {
  const reactRoot = typeof document !== "undefined" ? document.getElementById("react-root") : null
  const fromDom = reactRoot?.getAttribute("press-release-app-url")
  return (fromDom || PRESS_RELEASE_BASE_URL).replace(/\/+$/, "")
}

export const isPressReleaseV2Enabled = (featureGates) =>
  Array.isArray(featureGates) && featureGates.includes(PRESS_RELEASE_V2_GATE)

// Builds the Press Release app URL for the currently-active company, or null if
// the company DOM attributes are missing. Caller performs the navigation.
export const buildPressReleaseAppUrl = () => {
  const { companyId, companyName } = getCompanyDataFromDOM()
  const token = generateCompanyToken(companyId, companyName)
  if (!token) return null
  return `${getPressReleaseBaseUrl()}/c/${token}/`
}

// Shared click handler for the gated entry points: preventDefault + redirect,
// with the same user-facing failure mode as the ListSend handoff.
export const navigateToPressReleaseApp = (e) => {
  if (e) {
    e.preventDefault()
    e.stopPropagation()
  }
  const url = buildPressReleaseAppUrl()
  if (!url) {
    console.error("Failed to build Press Release app URL (missing company DOM attrs)")
    // eslint-disable-next-line no-alert
    alert("Company information not found. Please refresh the page and try again.")
    return false
  }
  window.location.href = url
  return false
}
